import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex align-items-center justify-content-center h-100"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "dialog-footer" }

import { ref } from "vue";
import ReportService from "../../services/ReportService";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'recordDetail',
  setup(__props, { expose: __expose }) {

const isLoading = ref(false);
const dialogRef = ref(false);
const data = ref<any>({});
const id = ref(0);
const show = async (_item: any) => {
  dialogRef.value = true;
  id.value = _item.id;
  await fetchData();
};

const fetchData = async () => {
  isLoading.value = true;
  try {
    const res = await ReportService.queryMessageRecordById(id.value);
    data.value = res;
  } catch (error) {
    console.log(error);
  }
  isLoading.value = false;
};

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: dialogRef.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogRef).value = $event)),
    title: _ctx.$t('fields.recordDetail'),
    direction: "rtl",
    size: "60%"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          type: "danger",
          plain: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (dialogRef.value = false)),
          disabled: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.close")), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    default: _withCtx(() => [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(ScaleLoader, { color: '#ffc730' })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_el_descriptions, {
              column: 3,
              border: "",
              class: "mb-3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_descriptions_item, { label: "ID" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(data.value?.id), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "Party ID" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(data.value?.receiverPartyId), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, {
                  label: _ctx.$t('fields.receiver')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(data.value?.receiver), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_descriptions_item, {
                  label: _ctx.$t('fields.receiverName')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(data.value?.receiverName), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_descriptions_item, {
                  label: _ctx.$t('fields.method')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(data.value?.method), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_descriptions_item, {
                  label: _ctx.$t('fields.eventId')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(data.value?.eventId), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_descriptions_item, {
                  label: _ctx.$t('fields.event')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(data.value?.event), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_descriptions_item, {
                  label: _ctx.$t('fields.status')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(data.value?.status), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_descriptions_item, {
                  label: _ctx.$t('fields.note')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(data.value?.note), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_descriptions_item, {
                  label: _ctx.$t('fields.createdOn')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_TimeShow, {
                      type: "GMToneLiner",
                      "date-iso-string": data.value.createdOn
                    }, null, 8, ["date-iso-string"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }),
            _createElementVNode("div", {
              innerHTML: data.value?.content
            }, null, 8, _hoisted_3)
          ]))
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})